import { createContext } from "react";

export const CommonContext = createContext({
    value:{},
    setValue :(value) =>{}

});